import React from 'react';
import { FormattedMessage } from 'react-intl';

import Checkbox from 'components/Shared/Inputs/Checkbox';
import { colors, fontSize } from 'styles/cp';

export interface BatchInvoiceTableHeaderRowProps {
  isAllChecked: boolean;
  handleSelectAllCheck: () => void;
  disabled?: boolean;
}

const BatchInvoiceTableHeaderRow = ({
  isAllChecked,
  handleSelectAllCheck,
  disabled = false,
}: BatchInvoiceTableHeaderRowProps) => {
  return (
    <div className="invoice-row-wrapper header-row">
      <div className="checkbox-column">
        <Checkbox
          checked={isAllChecked}
          onChange={handleSelectAllCheck}
          disabled={disabled}
          type="primary"
        />
      </div>
      <div className="invoice-number-wrapper">
        <FormattedMessage id="INVOICE" defaultMessage="Invoice" />
      </div>
      <div className="section-wrapper due-date-section">
        <div className="title">
          <FormattedMessage id="INVOICE_SUMMARY_DUE_DATE" defaultMessage="Due date" />
        </div>
      </div>
      <div className="section-wrapper amount-section">
        <div className="title">
          <FormattedMessage id="INVOICE_TOTAL_DUE" defaultMessage="Total due" />
        </div>
      </div>
      <div className="actions-column"></div>
      <style jsx>{`
        .title {
          font-weight: 600;
        }
        .actions-column {
          flex: 0 0 40px;
          display: flex;
        }
        .section-wrapper {
          flex: 1;
        }
        .invoice-row-wrapper {
          display: flex;
          width: 100%;
          height: 40px;
          padding: 12px;
          justify-content: space-between;
          align-items: center;
        }
        .amount-section {
          text-align: right;
        }
        .invoice-number-wrapper {
          width: 150px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .checkbox-column {
          width: 46px;
          display: flex;
        }
        .header-row {
          background-color: ${colors.stoneWhite01};
          font-family: AvenirNextforINTUIT-Demi;
          font-size: ${fontSize.xs};
          color: ${colors.black};
          border-bottom: 1px solid ${colors.stoneWhite};
        }
        .due-date-section {
          text-align: left;
        }
      `}</style>
    </div>
  );
};

export default BatchInvoiceTableHeaderRow;
